import { showInputError } from '../utils/domUtils';
import { attachEventListeners } from './FieldsetManager/fieldsetEvents';
import { setupMutationObserver, updateAllFieldsets } from './FieldsetManager/fieldsetObserver';
import { restFildSet } from './FieldsetManager/fieldsetUtilities';

export class FieldsetManager {
  constructor() {
    this.init();
  }

  init() {
    setupMutationObserver(this);
    updateAllFieldsets(this);
    attachEventListeners(this);
    document.querySelectorAll('fieldset').forEach((fieldset) => this.fieldsetLoadedEvent(fieldset));
  }

  // Публичный метод для сброса полей
  restFildSet(fieldset) {
    restFildSet(fieldset);
  }

  fieldsetLoadedEvent(fieldset) {
    if (!fieldset || !fieldset.elements) {
      return false;
    }

    const fieldsetUpdatedEvent = new CustomEvent('fieldsetLoaded', {
      detail: { target: fieldset },
      bubbles: true,
      cancelable: true,
      target: fieldset
    });

    fieldset.dispatchEvent(fieldsetUpdatedEvent);
  }

  validateFildSet(fieldset) {
    const activeInputs = Array.from(fieldset.querySelectorAll('input, select, textarea')).filter((input) => !input.disabled && !input.readOnly);

    for (let input of activeInputs) {
      if (input.type === 'hidden' && input.required) {
        if (!input.value) {
          const position = { top: '50px', left: '10px' };
          showInputError({ input: input, position: position, message: 'Заполните поле' });
          return false;
        }
      }

      if (!input.checkValidity()) {
        input.reportValidity(); // Показываем стандартное сообщение валидации
        return false;
      }
    }

    return true;
  }
}
